// extracted by mini-css-extract-plugin
module.exports = {"anim":"FadeUpAnim_anim__3yCOS","animation":"FadeUpAnim_animation__OMmgB"};